const resources = {
    giftFinder: 'Gift Finder'
};

export default function getResource(label) {
    return resources[label];
}
